import type { CmsIconChipAttributes } from '../../types/cms'
import FormattedImage from '../FormattedImage'
import { StyledChip } from './styles'

const IconChip = ({
  backgroundColour,
  label,
  labelColour,
  icon = {},
}: CmsIconChipAttributes) => {
  return (
    <StyledChip
      label={label}
      variant="filled"
      icon={icon && <FormattedImage image={icon} />}
      backgroundColour={backgroundColour}
      labelColour={labelColour}
    />
  )
}

export default IconChip
